import { Head, Link, useForm, usePage } from '@inertiajs/react'
import { FormEvent } from 'react'
import Alert from '../../components/Alert'
import PageHeader, { Wave } from '../../components/PageHeader'
import TextField from '../../components/TextField'
import { Flash } from '../../types'

export default function Verify({ email }: { email: string }) {
  const { props } = usePage<{ flash: Flash }>()
  const form = useForm({ email, code: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/login/verify')
  }

  return (
    <>
      <Head title="Enter code" />
      <main className="ho-screen">
        <PageHeader title="Check your email" subtitle="Enter the 6-digit code from your email." />
        <form className="ho-form" onSubmit={submit}>
          {props.flash?.alert && <Alert tone="error">{props.flash.alert}</Alert>}
          {props.flash?.notice && <Alert tone="info">{props.flash.notice}</Alert>}
          <TextField
            label="Verification code"
            name="code"
            required
            autoFocus
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="\d{6}"
            maxLength={6}
            placeholder="6-digit code"
            value={form.data.code}
            onChange={(e) => form.setData('code', e.target.value.replace(/\D/g, ''))}
          />
          <p className="ho-hint">Didn’t get it? Check your spam folder. The code expires in 5 minutes.</p>
          <button type="submit" className="ho-btn ho-btn-primary" disabled={form.processing}>
            {form.processing ? 'Verifying…' : 'Verify & log in'}
          </button>
          <p className="ho-foot"><Link href="/login">Use a different email</Link></p>
        </form>
        <Wave />
      </main>
    </>
  )
}
